// 价格格式化
const formatPrice = (value) => {
  if(!value) return '0.00';	
  let intPart =  Number(value)|0; //获取整数部分
  let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分每三位加一个逗号
  let floatPart = ".00"; //预定义小数部分
  if(typeof value !== 'string'){
    value = value.toString();
  }
  let value2Array = value.split(".");

  //=2表示数据有小数位
  if(value2Array.length == 2) {
    floatPart = value2Array[1].toString(); //拿到小数部分
    if(floatPart.length > 2 ) { //若小数位数在两位以上，则四舍五入保留两位小数
      return parseFloat(value).toFixed(2);
    } else if(floatPart.length == 1) { //若小数位数只有一位，补0
      return intPartFormat + "." + floatPart + '0';
    } else {
      return intPartFormat + "." + floatPart;
    }

  } else {  //数据为整数
    return intPartFormat + floatPart;
    }
}

module.exports = {
  formatPrice
}